module.exports = __webpack_public_path__ + "static/media/011.97b2518c.jpg";